import type { SkillRatingScale } from '@/api/types/jobEnd.types';

export const RATING_LABELS: Record<SkillRatingScale, string> = {
  BT: 'BT',
  OT_Minus: 'OT-',
  OT: 'OT',
  OT_Plus: 'OT+',
  AT: 'AT',
  O: 'O',
  NA: 'N/A',
};
